module.exports = __webpack_public_path__ + "static/microgrind-6b979b91ff802b37b0b17d34db3b7440.png";